<template>
    <div>
        <content-item :title="$t('history')">
            <div class="history">
                <img :src="historyPic"/>
            </div>
        </content-item>
    </div>
</template>

<script>
    import ContentItem from '../partial/ContentItem.vue'

    import Vue from 'vue'

    export default {
        data() {
            return {}
        },
        computed: {
            historyPic() {
                return '../../../static/img/about/' + Vue.config.lang + '.jpg';
            }
        },
        components: {
            ContentItem
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib.scss";

    $content-width: 950px;
    .history {
        @include flex-row-center;
        .marks {
            display: inline-block;
            width: $content-width;
            height: auto;

        }
    }


</style>



// WEBPACK FOOTER //
// History.vue?b484f2a2